import { RTABAK_URLS } from "../utils/urls";
import request from "./request";

type VariationParams = {
  id?: string;
};

const VariationService = {
  getVariationsByProductId: async (params?: VariationParams): Promise<any> => {
    return await request({
      method: "get",
      baseURL: RTABAK_URLS.API.getAllVariationsByProductId + params?.id,
    });
  },
};
export { VariationService };
